import React, { useContext, useState, useEffect } from 'react';
import { auth } from '../firebase';
import { getDatabase, child, ref, get } from 'firebase/database';
import { createUserWithEmailAndPassword, signInWithEmailAndPassword, signOut } from 'firebase/auth';
const AuthContext = React.createContext();
export const useAuth = () => {
	return useContext(AuthContext);
};
export const AuthProvider = ({ children }) => {
	const [currentUser, setCurrentUser] = useState();
	const [isAdmin, setAdmin] = useState(false);
	const [loading, setLoading] = useState(true);
	const signup = async (email, password) => {
		return createUserWithEmailAndPassword(auth, email, password);
	};
	const signin = async (email, password) => {
		return signInWithEmailAndPassword(auth, email, password);
	};
	const signout = async () => {
		return signOut(auth);
	};
	useEffect(() => {
		const unsubscribe = auth.onAuthStateChanged(user => {
			if (user) {
				const dbRef = ref(getDatabase());
				get(child(dbRef, `admins/${user.uid}`))
					.then(snapshot => {
						if (snapshot.exists()) {
							setAdmin(snapshot.val());
						}
					})
					.catch(error => {
						console.error('@onAuthStateChanged-->', error);
					});
			}
			setCurrentUser(user);
			setLoading(false);
		});
		return unsubscribe;
	}, []);
	const value = {
		currentUser,
		isAdmin,
		signup,
		signin,
		signout
	};
	return <AuthContext.Provider value={value}>{!loading && children}</AuthContext.Provider>;
};
